var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCameraIconActive = function SvgCameraIconActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04459 6.88556L6.89637 4.73734L2.43881 0.290527L0.924316 1.80502L3.85664 4.73734H3.07254C2.48178 4.73734 1.99843 5.22069 1.99843 5.81145V16.5526C1.99843 17.1433 2.48178 17.6267 3.07254 17.6267H15.9619C16.1874 17.6267 16.3808 17.5407 16.5526 17.4333L19.9683 20.849L21.4828 19.3345L11.9662 9.81789L9.04459 6.88556ZM4.14665 15.4784V6.88556H6.00486L14.5977 15.4784H4.14665ZM14.8878 6.88556V9.68899L21.3324 16.1337V5.2744L17.036 9.57084V5.81145C17.036 5.22069 16.5526 4.73734 15.9619 4.73734H9.9361L12.0843 6.88556H14.8878Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCameraIconActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "camera-icon-active.3091326e61943ea986f5d5464a0e8f00.svg";